package com.ijoin.data.api

import com.ijoin.data.api.ApiClient.addAuthToken
import com.ijoin.data.model.CancelSlotsRequest
import com.ijoin.data.model.CreateTimeOffRequest
import com.ijoin.data.model.SlotIdsRequest
import io.ktor.client.request.delete
import io.ktor.client.request.parameter
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

class ServiceProviderApi {
    private val client = ApiClient.client
    private val baseUrl = "${ApiClient.getBaseUrl()}/api/service-providers"

    suspend fun cancelSlots(eventId: String, request: CancelSlotsRequest): Result<Unit> {
        return safeApiCall {
            client.post("$baseUrl/$eventId/cancel-slots") {
                addAuthToken()
                contentType(ContentType.Application.Json)
                setBody(request)
            }
        }.map { }
    }

    suspend fun addEventTimeOff(eventId: String, request: CreateTimeOffRequest): Result<Unit> {
        return safeApiCall {
            client.post("$baseUrl/events/$eventId/time-offs") {
                addAuthToken()
                contentType(ContentType.Application.Json)
                setBody(request)
            }
        }.map { }
    }

    suspend fun restoreSlots(eventId: String, slotIds: List<Long>): Result<Unit> {
        val request = SlotIdsRequest(slotIds)
        return safeApiCall {
            client.post("$baseUrl/$eventId/restore-slots") {
                addAuthToken()
                contentType(ContentType.Application.Json)
                setBody(request)
            }
        }.map { }
    }

    suspend fun restoreEventDay(eventId: String, date: String): Result<Unit> {
        return safeApiCall {
            client.delete("$baseUrl/events/$eventId/time-offs") {
                addAuthToken()
                parameter("date", date)
            }
        }.map { }
    }
}
